"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOKENS_LIFETIME = exports.AUTH_TOKENS = void 0;
var api_utils_1 = require("./api.utils");
exports.AUTH_TOKENS = {
    'access': 'X-S7-Access',
    'refresh': 'X-S7-Refresh'
};
exports.TOKENS_LIFETIME = {
    'access': 15 * 60,
    'refresh': 30 * 24 * 60 * 60
};
var AuthTokenCookieService = /** @class */ (function () {
    function AuthTokenCookieService() {
    }
    var _a;
    _a = AuthTokenCookieService;
    AuthTokenCookieService.checkDocument = function () { return typeof document !== 'undefined'; };
    AuthTokenCookieService.getCookieDomain = function (hostname) {
        var host = hostname || (typeof window !== 'undefined' ? window.location.hostname : process.env.INTERNAL_API_URL);
        if ((0, api_utils_1.isLocalhost)(host)) {
            return typeof window === 'undefined' ? 'localhost' : window.location.hostname;
        }
        if ((0, api_utils_1.isStage)(host)) {
            return ".".concat((0, api_utils_1.parseStageDomain)(host));
        }
        return ".".concat((0, api_utils_1.parseDomain)(host));
    };
    AuthTokenCookieService.getToken = function (tokenType) {
        if (!_a.checkDocument())
            return '';
        var allCookies = document.cookie || '';
        var checker = "".concat(exports.AUTH_TOKENS[tokenType], "=");
        var tokenPair = allCookies.split('; ').find(function (pair) { return pair.startsWith(checker); }) || '';
        var _b = tokenPair.length ? tokenPair.split(checker) : [], _c = _b[1], token = _c === void 0 ? '' : _c;
        return decodeURIComponent(token);
    };
    AuthTokenCookieService.setToken = function (tokenType, token) {
        if (!_a.checkDocument())
            return;
        // INFO: -->.<--domain - dot before domain need to share token between subdomains
        document.cookie = "".concat(exports.AUTH_TOKENS[tokenType], "=").concat(encodeURIComponent(token), "; path=/; max-age=").concat(exports.TOKENS_LIFETIME[tokenType], "; domain=").concat(_a.getCookieDomain());
    };
    AuthTokenCookieService.removeToken = function (tokenType) {
        if (!_a.checkDocument())
            return;
        document.cookie = "".concat(exports.AUTH_TOKENS[tokenType], "=; max-age=-1; path=/; domain=").concat(_a.getCookieDomain());
    };
    return AuthTokenCookieService;
}());
exports.default = AuthTokenCookieService;
